var map = {
	"./google-play-badge-da-DK.svg": 73699,
	"./google-play-badge-de-DE.svg": 22465,
	"./google-play-badge-en-GB.svg": 84779,
	"./google-play-badge-en-US.svg": 75780,
	"./google-play-badge-es-ES.svg": 64531,
	"./google-play-badge-es-MX.svg": 76928,
	"./google-play-badge-fr-FR.svg": 57271,
	"./google-play-badge-it-IT.svg": 77497,
	"./google-play-badge-nb-NO.svg": 41130,
	"./google-play-badge-nl-NL.svg": 29583,
	"./google-play-badge-pl-PL.svg": 68019,
	"./google-play-badge-pt-BR.svg": 587,
	"./google-play-badge-pt-PT.svg": 34227,
	"./google-play-badge-sv-SE.svg": 28946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;